import constants from 'constants/constants';
import moment from 'moment-timezone';

import { MetricValueTypes } from '../../programStatusSummaryReportTypes';

export const getMainText = (value: number, valueType: MetricValueTypes) => {
    if (valueType === MetricValueTypes.date) {
        return moment(value).format(constants.formats.date.default);
    }
    if (valueType === MetricValueTypes.percent) {
        return `${value}%`;
    }

    return value.toString();
};
